<mat-dialog-content>
  <mat-icon>screen_share</mat-icon>
  <div class="title-1">Request Screen Sharing</div>
  @if (!sendingInProgress()) {
    <div class="request">{{ data?.sysAdminName }} has requested a screen sharing session with you. Do you accept?</div>
  }
  @if (sendingInProgress()) {
    <div class="progress-bar body-2">
      <mat-progress-bar mode="buffer" class="mb-20" />
      <span>Sharing screen...</span>
      <span>This should only take a second</span>
    </div>
  }
</mat-dialog-content>

@if (!sendingInProgress()) {
  <mat-divider class="mt-20! mx-20!" />
  <mat-dialog-actions>
    <button matButton="elevated" class="charcoal-button" type="button" mat-dialog-close (click)="cancelSharingScreen()">
      CANCEL
    </button>
    <button matButton="elevated" class="red-button" (click)="acceptSharingScreen()">CONFIRM</button>
  </mat-dialog-actions>
}
